import { UrlUtils } from "../url";

const baseUrl = UrlUtils.trimEndSlash(appSettings["Integrations:SAG:BaseAddress"]);
const environment = UrlUtils.trimEndSlash(appSettings["Integrations:SAG:Environment"]);
const sagSubscriptionKey = appSettings["Integrations:SAG:SubscriptionKey"];

function getSagBasicApiUrl(apiName: string) {
    return UrlUtils.trimEndSlash(`${baseUrl}/${apiName}`);
}

function getSagApiUrl(apiName: string, version?: string) {
    return `${getSagBasicApiUrl(apiName)}/${environment ? environment + "/" : ""}${version ? version + "/" : ""}`;
}

export function useSagOptions() {
    return {
        getSagApiUrl,
        getSagBasicApiUrl,
        sagSubscriptionKey,
    };
}
